<div class="bulk-upload-container">
  <div class="bulk-upload-container__header">
    <div class="bulk-upload-container__titles">
      <h2 class="bulk-upload-container__title">{{ 'COM.DIALOGS.BULK_UPLOAD.TITLE' | translate }}</h2>
      <p class="bulk-upload-container__subtitle">
        {{ 'COM.DIALOGS.BULK_UPLOAD.DESCRIPTION' | translate }}
      </p>
    </div>
    <button
      class="bulk-upload-container__close-btn"
      mat-icon-button
      mat-dialog-close
      data-cy="bulk-selection-close"
      aria-label="Dialog close"
      (click)="onCloseClick()"
    >
      <mat-icon class="circle-icon">close</mat-icon>
    </button>
  </div>
  <div class="toggle-buttons">
    <div
      class="toggle-button"
      [ngClass]="{ 'toggle-button__active': selectedToggleButtonSignal() === toggleButtonOptions.TemplateDownload }"
      (click)="setToggleOption(toggleButtonOptions.TemplateDownload)"
    >
      {{ 'COM.DIALOGS.BULK_UPLOAD.TEMPLATE_DOWNLOAD' | translate }}
    </div>
    <div
      class="toggle-button"
      [ngClass]="{ 'toggle-button__active': selectedToggleButtonSignal() === toggleButtonOptions.CsvUpload }"
      (click)="setToggleOption(toggleButtonOptions.CsvUpload)"
    >
      {{ 'COM.DIALOGS.BULK_UPLOAD.CSV_UPLOAD' | translate }}
    </div>
  </div>

  <div *ngIf="selectedToggleButtonSignal() === toggleButtonOptions.TemplateDownload">
    <div class="custom-date-picker">
      <div class="custom-date-picker__content" (click)="onCalendarClick()" #dateInputContainer>
        <label *ngIf="selectedDateRangeSignal()" class="custom-date-picker__label">{{ 'COM.DIALOGS.BULK_UPLOAD.SELECT_DATES' | translate }}</label>
        <input
          class="custom-date-picker__input"
          type="text"
          [value]="selectedDateRangeSignal()"
          [placeholder]="'COM.DIALOGS.BULK_UPLOAD.SELECT_DATES' | translate"
          readonly
        />
      </div>
      <button class="custom-date-picker__icon-btn" (click)="onCalendarClick()">
        <mat-icon>calendar_month</mat-icon>
      </button>
    </div>
    <div class="custom-date-picker__hint">{{ datePickerHint() }}</div>
    <div class="template-download-buttons">
      <button class="template-download-buttons__cancel-btn" (click)="onCloseClick()">{{ 'COM.DIALOGS.BULK_UPLOAD.CANCEL' | translate }}</button>
      <button
        color="primary"
        [disabled]="canDownloadTemplate() === false"
        data-cy="open-tab-edit-confirm-btn"
        class="template-download-buttons__upload-btn"
        (click)="onDownloadTemplate()"
      >
        <mat-icon>download</mat-icon> {{ 'COM.DIALOGS.BULK_UPLOAD.DOWNLOAD' | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="selectedToggleButtonSignal() === toggleButtonOptions.CsvUpload">
    <div
      *ngIf="uploadStatusSignal() === uploadStatusOptions.None"
      [ngClass]="{ 'file-drop-zone custom-dashed': true, 'file-drop-zone--active': dropZoneActiveSignal() }"
      drop-zone
      (filesChangeEmitter)="onFilesDropped($event)"
      (dragoverEmitter)="toggleDropZoneActive(true)"
      (dragleaveEmitter)="toggleDropZoneActive(false)"
      [allowedFilesExtensions]="['csv']"
    >
      <div class="file-drop-zone__icon"><mat-icon>upload</mat-icon></div>
      <div class="file-drop-zone__main-text">
        <span>{{ 'COM.DIALOGS.BULK_UPLOAD.DROP_FILES' | translate }}</span>
        <input type="file" accept=".csv" #fileInput hidden (change)="onFileSelected(fileInput)" />
        <button class="file-drop-zone__main-text-button" (click)="fileInput.click()">{{ 'COM.DIALOGS.BULK_UPLOAD.BROWSE' | translate }}</button>
      </div>
      <span class="file-drop-zone__sub-text">{{ 'COM.DIALOGS.BULK_UPLOAD.ONLY_CSV_FILES' | translate }}</span>
    </div>

    <div
      *ngIf="uploadStatusSignal() !== uploadStatusOptions.None"
      class="uploading-file"
      [ngClass]="{ 'uploaded-file': uploadStatusSignal() === uploadStatusOptions.Loaded }"
    >
      <div class="uploading-file__header">
        <div class="uploading-file__left-icon">
          <mat-icon>description</mat-icon>
        </div>
        <div class="uploading-file__fill">
          <span class="uploading-file__title" [ngClass]="{ 'uploaded-file__title': uploadStatusSignal() === uploadStatusOptions.Loaded }">{{
            fileSignal()?.name
          }}</span>
          <div class="uploading-file__subtitle">
            <span *ngIf="uploadStatusSignal() === uploadStatusOptions.Uploading" class="uploading-file__subtitle--blue">
              {{ 'COM.DIALOGS.BULK_UPLOAD.UPLOADING' | translate }}</span
            >
            <span *ngIf="uploadStatusSignal() === uploadStatusOptions.Processing" class="uploading-file__subtitle--blue">
              {{ uploadStatusLabelSignal() }}</span
            >
            <span *ngIf="uploadStatusSignal() === uploadStatusOptions.Processing" class="uploading-file__subtitle--blue">
              {{ bulkImportPercent$ | async | number: '1.0-0' }}%</span
            >
            <span
              class="uploading-file__subtitle--file-size"
              [ngClass]="{ 'uploaded-file__subtitle--file-size': uploadStatusSignal() === uploadStatusOptions.Loaded }"
              >{{ fileSizeSignal() }}</span
            >
          </div>
        </div>
        <div class="uploading-file__right-buttons">
          <button class="uploading-file__right-buttons--btn" *ngIf="uploadStatusSignal() === uploadStatusOptions.Uploading">
            <mat-icon>pause</mat-icon>
          </button>

          <div class="uploading-file__right-buttons--separator" *ngIf="uploadStatusSignal() === uploadStatusOptions.Uploading"></div>
          <button
            class="uploading-file__right-buttons--btn"
            (click)="cleanSelectedFile()"
            *ngIf="uploadStatusSignal() !== uploadStatusOptions.Processing"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <div
        *ngIf="uploadStatusSignal() === uploadStatusOptions.Uploading || uploadStatusSignal() === uploadStatusOptions.Processing"
        class="progress-bar"
      >
        <div class="progress-bar__track">
          <div
            class="progress-bar__fill"
            [class.progress-bar__fill--indeterminate]="uploadStatusSignal() === uploadStatusOptions.Processing"
            [style.width.%]="uploadStatusSignal() === uploadStatusOptions.Uploading ? uploadProgressSignal() : null"
          ></div>
        </div>
      </div>
    </div>
    <div></div>
    <div class="template-download-buttons">
      <button class="template-download-buttons__cancel-btn" (click)="onCloseClick()">{{ 'COM.DIALOGS.BULK_UPLOAD.CANCEL' | translate }}</button>
      <button
        color="primary"
        [disabled]="
          !fileSignal() || uploadStatusSignal() === uploadStatusOptions.Uploading || uploadStatusSignal() === uploadStatusOptions.Processing
        "
        data-cy="open-tab-edit-confirm-btn"
        class="template-download-buttons__upload-btn"
        (click)="onConfirmUpload()"
      >
        {{ 'COM.DIALOGS.BULK_UPLOAD.CONFIRM' | translate }}
      </button>
    </div>
  </div>
</div>
